import { Link } from 'react-router-dom';
import { primaryNav } from '@/mocks/gossip';

interface BreadcrumbsProps {
  items: { label: string; path?: string }[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  const hrefFor = (label: string, path?: string) => {
    if (path) return path;
    return primaryNav.find((item) => item.label === label)?.path || '/';
  };

  return (
    <nav aria-label="面包屑导航" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto flex max-w-[1240px] flex-wrap items-center gap-2 px-4 py-3 text-xs text-foreground-600 md:px-8 md:text-sm">
        <i className="ri-home-4-line text-sm" aria-hidden="true"></i>
        {items.map((item, index) => (
          <span key={`${item.label}-${index}`} className="flex items-center gap-2">
            {index > 0 && <span className="text-foreground-300">/</span>}
            {index === items.length - 1 ? (
              <span className="font-medium text-foreground-900">{item.label}</span>
            ) : (
              <Link
                to={hrefFor(item.label, item.path)}
                className="transition-colors hover:text-primary-600"
              >
                {item.label}
              </Link>
            )}
          </span>
        ))}
      </div>
    </nav>
  );
}